import classes from './Checkbox.module.scss';

const Checkbox = ({ validation, kind, type = 'simple', input, className = '', register = () => { }, ...props }) => {
	const handleDivClick = (e) => {
        // Prevent triggering the click event twice when clicking on the input
        if (e.target.tagName !== 'LABEL' && e.target.tagName !== 'SPAN') {
            const checkbox = e.currentTarget.querySelector('input[type="checkbox"]');
            if (checkbox) {
                checkbox.click(); // Programmatically trigger the checkbox click
            }
        }
    };
    return (
        <>
            {type === 'survey' ? (
                <div
                    className={`${classes['survey']} position-relative`}
					 onClick={handleDivClick}
                >
                    <label
                        className={`${classes['checkbox-container']}`}
						htmlFor={input.id}
                       >
                        {input.label}
                        <input type="checkbox" {...input} {...register(input.name, validation)} {...props} />
                        <span></span>
                    </label>
                </div>
            ) : (
                <label
                    className={`${classes['checkbox-container']} ${kind ? classes[kind] : className}`}
                    htmlFor={input.id}>
                    {input.label}
                    <input type="checkbox" {...input} {...register(input.name, validation)} {...props} />
                    <span></span>
                </label>
            )}
        </>
    );
};

export default Checkbox;
